import React from "react";
import "./style.css";

const PageNotFound = () => {
  return (
    <div className="hero-about">
      <img src="/javascript.jpg" alt="javascript logo" />
      <div className="hero-text-about">
        <h1>Page Not Found</h1>
      </div>
    </div>
  );
};

export default PageNotFound;
